<template>
  <div id="app">

    <b-container class="h-100">
      <b-row class="h-100 justify-content-center align-items-center">

          <b-card
            :title="title"
            img-src="./assets/mainlogo_1280width-installerpadded.png"
            :img-alt="title"
            img-top
            tag="article"
            style="max-width: 30rem;"
            class="col-12"
          >
          
            <template v-if="installStep == 1 && workspaceInstallCode === false">
              <b-card-text class="text-left">
                Sorry, but this installer is only accessible through Slack.
              </b-card-text>
            </template>
            <template v-else>
              <b-progress 
                :value="installProgress" 
                :max="installProgressMax" 
                variant="info"
                class="mb-4"
                style="height: 20px;"></b-progress>

              <!-- The main router-determined view -->
              <router-view/>

            </template>

          </b-card>
      </b-row>  
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  },

  computed: {
    installStep() {
      return this.$store.state.installStep
    },
    installProgress() {
      return this.$store.state.installProgress
    },
    installProgressMax() {
      return this.$store.state.installProgressMax
    },

    stepOverride() {
      if('stepOverride' in this.$route.query) {
        return this.$route.query.stepOverride
      } else {
        return false
      }
    },

    workspaceInstallCode() {
      if('code' in this.$route.query && this.$route.query.code.length > 26) {
        return this.$route.query.code
      } else {
        return false
      }
    }
  },

  data: function () {
    return {
      title: 'Workspace Installer'
    }
  },

  mounted() {
    if(this.workspaceInstallCode !== false) {
      this.$store.commit('installCode', this.workspaceInstallCode)
    }

    if(this.stepOverride !== false) {
      this.$store.commit('installStep', this.stepOverride)
    }

    // local testing
    // this.$store.commit('numericTeamId', 1)
    // this.$store.commit('installStep', 3)
    
  }
}
</script>


<style lang="scss">

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

body, html {
  height: 100%;
  background-color: #f0f3f5;
}

.bg-info {
  background-color: #664d93 !important;
}

.btn-primary {
  background-color: #664d93 !important;
  border-color: #664d93 !important;
}

.btn-secondary {
  background-color: #20c997 !important;
  border-color: #20c997 !important;
}

.btn-danger {
  background-color: #f86c6b !important;
  border-color: #f86c6b !important;
}

.alert-info {
  background-color: #c0ade4 !important;
  color: #2a3846 !important;
}


#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

</style>
